// extracted by mini-css-extract-plugin
export default {"Avatar":"styles_Avatar__k7y1P","text":"styles_text__RV76c"};